export type SponsorId = 'HYPERNEON' | 'DRIFTLAB' | 'SAFEWHEELS';

export type SponsorContract = {
  id: SponsorId;
  name: string;
  description: string;
  racesRequired: number;
  minDriftScore?: number;
  maxHeatLevel?: number;
  moneyBonus: number;
  moneyMultiplier: number;
  xpMultiplier: number;
  progress: {
    racesDone: number;
    completed: boolean;
  };
};

export const DEFAULT_SPONSORS: Record<SponsorId, Omit<SponsorContract, 'progress'>> = {
  HYPERNEON: {
    id: 'HYPERNEON',
    name: 'HyperNeon',
    description: 'Mehr Cash pro Rennen, aber Polizei mag das nicht.',
    racesRequired: 5,
    moneyBonus: 3500,
    moneyMultiplier: 1.2,
    xpMultiplier: 1.05,
    maxHeatLevel: 3
  },
  DRIFTLAB: {
    id: 'DRIFTLAB',
    name: 'DriftLab',
    description: 'Bonus, wenn du saubere Drifts machst.',
    racesRequired: 4,
    minDriftScore: 600,
    moneyBonus: 2800,
    moneyMultiplier: 1.1,
    xpMultiplier: 1.15,
    maxHeatLevel: 3
  },
  SAFEWHEELS: {
    id: 'SAFEWHEELS',
    name: 'SafeWheels',
    description: 'Unauffaellig fahren: niedriger Heat-Level, stabile Boni.',
    racesRequired: 6,
    moneyBonus: 4000,
    moneyMultiplier: 1.12,
    xpMultiplier: 1.1,
    maxHeatLevel: 1
  }
};

export function createContract(id: SponsorId): SponsorContract {
  const base = DEFAULT_SPONSORS[id];
  return { ...base, progress: { racesDone: 0, completed: false } };
}

export function applySponsorMultipliers(contract: SponsorContract | null, money: number, xp: number) {
  if (!contract || contract.progress.completed) return { money, xp };
  return {
    money: Math.floor(money * contract.moneyMultiplier),
    xp: Math.floor(xp * contract.xpMultiplier)
  };
}

export type SponsorRaceSnapshot = {
  driftScore: number;
  heatLevel: number;
};

export function updateContractProgress(
  contract: SponsorContract,
  snap: SponsorRaceSnapshot
): { contract: SponsorContract; completedNow: boolean } {
  if (contract.progress.completed) return { contract, completedNow: false };

  if (typeof contract.maxHeatLevel === 'number' && snap.heatLevel > contract.maxHeatLevel) {
    return { contract, completedNow: false };
  }
  if (typeof contract.minDriftScore === 'number' && snap.driftScore < contract.minDriftScore) {
    return { contract, completedNow: false };
  }

  const next: SponsorContract = {
    ...contract,
    progress: { ...contract.progress, racesDone: contract.progress.racesDone + 1 }
  };

  if (next.progress.racesDone >= next.racesRequired) {
    next.progress.completed = true;
    return { contract: next, completedNow: true };
  }
  return { contract: next, completedNow: false };
}
